var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftArrowCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 11.5,
    transform: "matrix(-1 0 0 1 23 0.173828)",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 11.5,
    transform: "matrix(-1 0 0 1 23 0.173828)",
    stroke: "#3F3F3F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 17.6738L9.5 11.8503L14.5 6.67383",
    stroke: "#3F3F3F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrowCalendar);
export default __webpack_public_path__ + "static/media/left-arrow-calendar.a30fc84ac1bf246ba35749517606c28e.svg";
export { ForwardRef as ReactComponent };